import { inject, Injectable } from '@angular/core';
import { CanActivate, CanActivateFn, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

/** Public landing only: send authenticated users to the dashboard. */
export const redirectAuthenticatedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.ensureValidSession().pipe(
    map((ok) => {
      if (ok) {
        router.navigate(['/dashboard']);
        return false;
      }
      return true;
    })
  );
};

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.ensureValidSession().pipe(
      map((ok) => {
        if (ok) {
          return true;
        }
        this.router.navigate(['/login'], { queryParams: { reason: 'session' } });
        return false;
      })
    );
  }
}
